import { Component, Input, OnInit } from '@angular/core';
import { PaginationPageEvent } from '@snapon/design-system-angular';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { LnOrdersService } from '../services/ln-orders.service';
import { LnOrderDetails } from '../../entities/ln-order-details-entity';

@Component({
  selector: 'app-ln-order-details',
  templateUrl: './ln-order-details.component.html',
  styleUrls: ['./ln-order-details.component.scss'],
  standalone: false
})
export class LnOrderDetailsComponent implements OnInit {
  appStrings: AppLocalization;
  lnOrderDetailsResult: LnOrderDetails[];
  totalRecords = 0;
  currentPage = 0;
  pageSize = 50;
  pageOffset = 0;
  totalPages: number;
  dataLoaded = {
    templateValues: false,
    orderDetails: false,
  };

  displayedColumns: string[] = [
    'erp',
    'item',
    'description',
    'shipQuantity',
    'backOrderQuantity',
    'orderQuantity',
    'trackingNumber',
    'netPrice',
    'totalPrice',
  ];
  @Input() lnOrderNumber: string;
  @Input() currencySymbol: string;

  constructor(
    private appInfoService: AppInfoService,
    private lnOrderService: LnOrdersService
  ) { }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.loadOrderDetails();
  }

  /**
   * Loads a page
   * @param event - The page event
   */
  loadPage(event: PaginationPageEvent) {
    this.dataLoaded.orderDetails = false;
    this.currentPage = event.pageNumber;
    this.loadOrderDetails(event.pageNumber);
    this.pageOffset = (event.pageNumber - 1) * this.pageSize;
  }

  /**
   * Get order details
   * @param pageIndex - details page index
   */
  loadOrderDetails(pageIndex?: number) {
    this.dataLoaded.orderDetails = false;
    this.lnOrderService.getOrderDetails({ lnOrderNumber: this.lnOrderNumber, page: pageIndex ? pageIndex + 1 : 0 }, lnOrderDetails => {
      this.lnOrderDetailsResult = lnOrderDetails.items;
      this.dataLoaded.orderDetails = true;
      this.totalRecords = lnOrderDetails.count;
      this.totalPages = Math.ceil(lnOrderDetails.count / this.pageSize);
    });
  }
}
